<template>
    <div class="widthBox">
        <h1 class="title f-28">PHROMON's Vlog</h1>
        <el-row :gutter="10">
            <el-col :span="6" :xs="24" v-for="(item, index) in video_list" :key="index" class="cursor" style="margin-bottom: 20px;"  @click.native="show_video(index)">
                <img style="height: 180px;object-fit: cover;" :src="item.thumbnail_url" class="img100 radius-8" alt="">
                <div class="txt f-20 line_Hide_1">{{ item.name }}</div>
                <div class="info line_Hide_2" style="min-height: 38px;">{{ item.desc }}</div>
            </el-col>
        </el-row>

        <div class="txt_center pageBox">
            <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :page-count="count"
                @current-change="change"
                >
            </el-pagination>
        </div>
        <div class="show_box_bg" v-if="show">
            <div class="acea-row row-center row-middle show_box">
				<video controls :src="video_list[show_index].video_url" class="img100 radius-8"></video>
                <div class="text">
                    <div class="txt f-20">{{ video_list[show_index].name }}</div>
                    <div class="info">{{ video_list[show_index].desc }}</div>
                </div>
                <div class="close" @click="(show = false)">
                    <img v-if="!xs" src="@/assets/close2.png" style="width: 24px;height: 24px;" alt="">
                    <img v-if="xs" src="@/assets/close3.png" style="width: 24px;height: 24px;" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Vlog",
    data() {
        return {
            video_list: [ ],
            show_index: 0,
            show: false,
            xs:false,
            count:1,
            query:{
                page:1,
                limit:8
            }
        }
    },
    created(){
        if(window.innerWidth < 750){
            this.xs = true
        }
        this.get_info();
        // console.log(window.innerWidth,this.xs )
    },
    methods:{
        show_video(index){
            this.show_index = index;
            this.show = true
        },
        change(e){
            this.query.page = e;
            this.get_info();
        },
        async get_info(){
            let res = await this.$api.get("api/company.Video/list", this.query);
            this.video_list = res.data.video_list.list;
            this.count = res.data.video_list.pages; 
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.title {
    margin-bottom: 40px;
    margin-top: 80px;
}

.pageBox {
    margin-top: 120px;
}

.txt {
    margin-top: 16px;
}

.info {
    margin-top: 8px;
}

.show_box_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    .show_box {
        width: calc(100% - 100% / 3);
        padding: 40px;
        background: #fff;
        border-radius: 8px;
        display: flex;
        position: relative;
        .close{
            position: absolute;
            top: -24px;
            right: -24px;
            cursor: pointer;
        }
        video {
            width: 50%;
        }

        .text {
            flex: 1;
            margin-left: 2%;
        }
    }
}

@media screen and(max-width:768px) {
    .pageBox {
        margin-top: 56px;
    }

    .title {
        text-align: center;
    }

    .txt {
        margin-top: 24px;
    }

    .info {
        margin-top: 12px;
        font-size: 14px;
        margin-bottom: 32px;
    }
    
    .show_box_bg {
        align-items: flex-end;
        .show_box {
            width: calc(100%);
            padding: 20px;
            padding-top: 64px;
            background: #fff;
            border-radius: 8px 8px 0 0;
            height: 70%;;
            flex-wrap: wrap;
            align-content: flex-start;
            .close{
                position: absolute;
                top: 24px;
                right: 24px;
                cursor: pointer;
            }
            video {
                width: 100%;
            }

            .text {
                width: 100%;
                margin: 0;
            }
        }
    }

}</style>